export class SapError extends Error {
  public sapErrorCode?: string;
  public httpStatusCode?: number;

  public constructor(message?: string, sapErrorCode?: string, httpStatusCode?: number) {
    super(message);
    this.sapErrorCode = sapErrorCode;
    this.httpStatusCode = httpStatusCode;
  }
}
